import React, { forwardRef, ReactNode, SVGAttributes } from "react";
import { useCss, k, a } from "kremling";

import { iconMigrateList } from "./icon-migrate";
import { Icons } from "../../types/icon";

export type CpIconProps = SVGAttributes<SVGElement> & {
  name: Icons | (string & {});
  size?: number;
  className?: string;
  fill?: string;
  intent?: "ai";
};

export type CpIconDynamic = Icons | (string & {}) | CpIconProps | ReactNode;

export const CpIcon = forwardRef<SVGSVGElement, CpIconProps>(function CpIcon(
  { name, size, className, fill, style, intent, ...rest },
  ref,
) {
  const scope = useCss(css);
  const newName = (iconMigrateList as Record<string, string>)[name];
  if (newName && newName !== name) {
    console.warn(
      `It seems you may be looking for '${newName}' rather than '${name}' for your CpIcon name`,
    );
  }
  return (
    <svg
      ref={ref}
      {...scope}
      className={a(`cp-icon ${name}`).a(className)}
      data-testid={`cp-icon-${name}`}
      style={{
        ...(size
          ? {
              width: `${size / 10}rem`,
              height: `${size / 10}rem`,
              minWidth: `${size / 10}rem`,
            }
          : {}),
        ...(fill && !intent ? { fill } : {}),
        ...(style || {}),
      }}
      viewBox="0 0 24 24"
      {...rest}
    >
      <use
        href={`#${name}`}
        xlinkHref={`#${name}`}
        fill={intent === "ai" ? "url(#ai_gradient)" : undefined}
      />
      {intent === "ai" && (
        <linearGradient
          id="ai_gradient"
          x1="-80%"
          y1="50%"
          x2="112%"
          y2="50%"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0%" stop-color="var(--cp-color-app-gradient-primary)" />
          <stop
            offset="51%"
            stop-color="var(--cp-color-app-gradient-primary)"
          />
          <stop
            offset="100%"
            stop-color="var(--cp-color-app-gradient-secondary)"
          />
        </linearGradient>
      )}
    </svg>
  );
});

const css = k`
  .cp-icon {
    display: inline-block;
    vertical-align: middle;
    fill: currentColor;
    width: 2.4rem;
    min-width: 2.4rem;
    height: 2.4rem;
  }
`;
